/* eslint-disable import/order */
import React from 'react';

import { useLocalStorage } from 'utils/hooks/useLocalStorage';
import { KEYS } from '../utils/constants';
import ContidionList from '../ContidionList';

const PathSelector = () => {
  const [conditions, setConditions] = useLocalStorage(KEYS.CONDITIONS, []);

  const handleSelectCondition = (condition) => {
    setConditions((prevConditions) => {
      const conditionInConditions = prevConditions.find((currCondition) => currCondition === condition);
      if (conditionInConditions) {
        return prevConditions.filter((currCondition) => currCondition !== condition);
      }
      return [...prevConditions, condition];
    });
  };

  return (
    <section className="path-selector">
      <ContidionList conditions={conditions} selectCondition={handleSelectCondition} />
    </section>
  );
};

export default PathSelector;
